export default {"src":"/_next/static/media/app-store_badge_zh-tw.ac0a172c.svg","height":40,"width":109};